import { render } from "./CusImage.vue?vue&type=template&id=ee3962a4"
const script = {}

import exportComponent from "D:\\后台PC\\Yiwu_Commodity_WMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__